import React, { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import BaseImage from '../Base/BaseImage/BaseImage';

const Logo: FC = () => {
  return (
    <Flex>
      <BaseImage
        src={'/assets/img/logo/logo.png'}
        alt='Insurance Market'
        dimensions={[250, 45]}
        priority={true}
      />
    </Flex>
  );
};
export default Logo;
